<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path d="M6.78 0a3.733 3.733 0 0 0-2.673 1.135A3.928 3.928 0 0 0 3 3.877v19.2a.933.933 0 0 0 .49.82.881.881 0 0 0 .936-.073L12 18.216l7.573 5.61a.887.887 0 0 0 .937.072.91.91 0 0 0 .358-.34.94.94 0 0 0 .132-.482v-19.2a3.928 3.928 0 0 0-1.107-2.74A3.733 3.733 0 0 0 17.22 0H6.78Z"/>
</svg>
